<div class="stacked-bar-container" [style.height.px]="height">
    <canvas #stackedBar height="{{height}}" width="{{width}}"></canvas>
</div>
